const VConsole = require('vconsole')
const config = require('./config')
const hook = require('./hook')
const utils = require('./utils')

const version = 'hxphone-main ' + VERSION + ' build ' + COMMITHASH + ' environment:' + process.env.NODE_ENV //eslint-disable-line
const vconsole = new VConsole({
  onReady: _ => vconsole.hideSwitch()
})
VConsole.prototype.download = function() {
  const txt = JSON.stringify({
    url: location.href,
    userAgent: navigator.userAgent,
    referrer: document.referrer,
    allLog: this.pluginList.default.$tabbox.innerText.split(/[\t\n]/),
    network: this.pluginList.network.reqList,
    storage: {
      cookie: document.cookie,
      localStorage: window.localStorage,
      sessionStorage: window.sessionStorage,
    }
  })
  const a = document.createElement('a')
  const fileName = `Hxphone Log(${(new Date()).toLocaleString()})`
  const fileBlob = new Blob([txt], {type: 'text/plain'})
  a.download = fileName
  const href = URL.createObjectURL(fileBlob)
  a.href = href
  a.click()
  URL.revokeObjectURL(href)
}

module.exports = {
  version,
  vconsole,
  config,
  hook,
  utils,
  options: {},
}



// WEBPACK FOOTER //
// ./src/js/global/module.js